module.exports = __webpack_public_path__ + "9fc532ea15d9acfc1e2d836e2a1ddb51.png";